<template>
  <transition name="toast">
    <div 
      v-if="alert" 
      :class="[
        'fixed top-4 right-4 z-[9999] max-w-xs w-full rounded-xl shadow-xl overflow-hidden border border-white border-opacity-20',
        alertTypeClasses
      ]"
    >
      <div class="flex items-start p-4">
        <!-- Icon -->
        <div :class="iconClasses" class="flex-shrink-0 mt-0.5 mr-3">
          <svg class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path v-if="alertType === 'success'" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
            <path v-if="alertType === 'error'" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
            <path v-if="alertType === 'info'" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            <path v-if="alertType === 'warning'" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01M10.29 3.86l-7 14A1 1 0 004 20h16a1 1 0 00.9-1.45l-7-14a1 1 0 00-1.8 0z" />
          </svg>
        </div>

        <!-- Content -->
        <div class="flex-1">
          <h3 :class="titleClasses" class="text-sm font-bold">
            {{ alertTitle }}
          </h3>
          <p :class="textClasses" class="mt-1 text-sm">
            {{ alert }}
          </p>
        </div>

        <!-- Close button -->
        <button 
          @click="$store.commit('clearAlert')" 
          class="ml-4 flex-shrink-0 text-white text-opacity-70 hover:text-opacity-100 focus:outline-none transition-opacity duration-200"
        >
          <svg class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      </div>

      <!-- Progress bar -->
      <div class="h-1 w-full bg-black bg-opacity-20">
        <div 
          class="h-full transition-all duration-300 ease-linear" 
          :class="progressBarClasses"
          :style="{ width: progress + '%' }"
        ></div>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapState } from "vuex";

export default {
  data() {
    return {
      progress: 100,
      interval: null,
      alertTitleMap: {
        success: 'Success!',
        error: 'Error!',
        info: 'Info',
        warning: 'Warning!'
      }
    }
  },
  computed: {
    ...mapState(["alert", "alertType"]),
    alertTitle() {
      return this.alertTitleMap[this.alertType] || 'Notification';
    },
    alertTypeClasses() {
      return {
        success: 'bg-gradient-to-r from-green-500 to-emerald-600',
        error: 'bg-gradient-to-r from-red-500 to-rose-600',
        info: 'bg-gradient-to-r from-blue-500 to-indigo-600',
        warning: 'bg-gradient-to-r from-yellow-600 to-orange-600' // darker and readable
      }[this.alertType];
    },
    iconClasses() {
      return 'text-white';
    },
    titleClasses() {
      return 'text-white';
    },
    textClasses() {
      return 'text-white text-opacity-90';
    },
    progressBarClasses() {
      return {
        success: 'bg-emerald-300',
        error: 'bg-rose-300',
        info: 'bg-indigo-300',
        warning: 'bg-orange-400'
      }[this.alertType];
    }
  },
  watch: {
    alert(newVal) {
      if (newVal) {
        this.startProgressBar();
      }
    }
  },
  methods: {
    startProgressBar() {
      this.progress = 100;
      clearInterval(this.interval);

      this.interval = setInterval(() => {
        this.progress -= 1;
        if (this.progress <= 0) {
          clearInterval(this.interval);
          this.$store.commit('clearAlert');
        }
      }, 50);
    }
  },
  beforeUnmount() {
    clearInterval(this.interval);
  }
}
</script>

<style scoped>
.toast-enter-active,
.toast-leave-active {
  transition: all 0.3s cubic-bezier(0.68, -0.55, 0.265, 1.55);
}
.toast-enter-from {
  opacity: 0;
  transform: translateX(100px);
}
.toast-leave-to {
  opacity: 0;
  transform: translateY(-20px);
}
</style>
